module.exports = __webpack_public_path__ + "assets/9917ce735395b26dc861acb66e2e4d96.svg";